import { getStore } from '../store/store';
import Permission from 'owa-service/lib/contract/Permission';
import { mutator } from 'satcheljs';
import {
    updateFolderPermissionsInUIStore,
    showHideFolderPermissionDialog,
    addPermissionUser,
    deletePermissionUser,
    changePermissionLevel,
    changeFolderPermissionProperty,
} from '../actions/internalActions';
import getPermissionFromPermissionLevel from '../helpers/getPermissionFromPermissionLevel';
import getPermissionLevelFromPermission from '../helpers/getPermissionLevelFromPermission';
import getSelectedPermission from '../helpers/getSelectedPermission';

// This mutator will initialize permissions in the folder permissions store.
export const updateFolderPermissionsInUIStoreMutator = mutator(
    updateFolderPermissionsInUIStore,
    actionMessage => {
        getStore().permissions = actionMessage.permissions;
    }
);

// This mutator will reset permissions in the folder permissions store.
export const resetPermissionOnCloseDialogMutator = mutator(
    showHideFolderPermissionDialog,
    actionMessage => {
        // When the dialog gets closed then shouldShow will be falsy. Reset at this time.
        if (!actionMessage.shouldShow) {
            getStore().permissions = [];
        }
    }
);

// This mutator will add a new permission user in permissions arrays of store.
export const addUserPermissionMutator = mutator(addPermissionUser, actionMessage => {
    const folderPermissionsStore = getStore();
    const permissionsLengthInStore = folderPermissionsStore.permissions.length;

    // TODO: WI 33253 - Use utility function to get permission object related to permissionLevel None.
    const newPermission: Permission = {
        ReadItems: 'None',
        PermissionLevel: 'None',
        CanCreateItems: false,
        CanCreateSubFolders: false,
        IsFolderOwner: false,
        IsFolderVisible: false,
        IsFolderContact: false,
        EditItems: 'None',
        DeleteItems: 'None',
        UserId: {
            PrimarySmtpAddress: actionMessage.primarySmtpAddress,
            DisplayName: actionMessage.displayName,
        },
    };
    folderPermissionsStore.permissions.push(newPermission);
    folderPermissionsStore.selectedPermissionIndex = permissionsLengthInStore;
});

// This mutator will delete user permission from store for a given index only if the user is not distinguished user.
export const deleteUserPermissionMutator = mutator(deletePermissionUser, actionMessage => {
    const folderPermissionsStore = getStore();
    const permissionsLengthInStore = folderPermissionsStore.permissions.length;
    const selectedPermissionIndex = folderPermissionsStore.selectedPermissionIndex;

    // Check if the permission user is not distinguished user.
    folderPermissionsStore.permissions.splice(selectedPermissionIndex, 1);

    // Check if last permission was selected or not, and user for that permission is distinguished or not.
    if (selectedPermissionIndex === permissionsLengthInStore - 1) {
        folderPermissionsStore.selectedPermissionIndex--;
    }
});
/**
 * This mutator will update permission object on the basis of permission level selected.
 */
export const changePermissionLevelMutator = mutator(changePermissionLevel, actionMessage => {
    const { permissions, selectedPermissionIndex } = getStore();
    const permissionObj = getPermissionFromPermissionLevel(actionMessage.permissionLevel);
    permissions[selectedPermissionIndex] = {
        ...getSelectedPermission(),
        ...permissionObj,
    };
});

/**
 * This mutator will update permission level, and the property modified on the basis of new permission object.
 */
export const changeFolderPermissionPropertyMutator = mutator(
    changeFolderPermissionProperty,
    actionMessage => {
        const { propertyName, value } = actionMessage;
        const { permissions, selectedPermissionIndex } = getStore();
        const permissionObj = { ...getSelectedPermission() };
        permissionObj[propertyName] = value;
        permissionObj.PermissionLevel = getPermissionLevelFromPermission(permissionObj);
        permissions[selectedPermissionIndex] = permissionObj;
    }
);
